import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime-corejs3/helpers/objectSpread2";
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import { __REDWOOD__ } from "../config";
export { withCell } from "./withCell";
var DEFAULT_CLIENT_CONFIG = {
  uri: "".concat(__REDWOOD__.API_PROXY_PATH, "/graphql")
};
export var createGraphQLClient = function createGraphQLClient(config) {
  return new ApolloClient(_objectSpread({}, DEFAULT_CLIENT_CONFIG, {}, config));
};
export var GraphQLProvider = function GraphQLProvider(_ref) {
  var _ref$client = _ref.client,
      client = _ref$client === void 0 ? createGraphQLClient() : _ref$client,
      rest = _objectWithoutProperties(_ref, ["client"]);

  return React.createElement(ApolloProvider, _extends({
    client: client
  }, rest));
};